<template>
  <div class="parent">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>

    <div class="selectParent">
      <div class="selectitem1">
        <router-link to="/class" active-class="u-link--Active1">
          <div class="select1">课时核对</div>
        </router-link>
      </div>

      <div class="selectitem2">
        <router-link to="/record" active-class="u-link--Active2">
          <div class="select1">我的档案</div>
        </router-link>
      </div>

      <!-- 路由出口 -->
      <!-- 路由匹配到的组件将渲染在这里 -->

    </div>


  </div>
</template>

<script>
  export default {
    name: 'parent-main',
    destroyed() {
    }
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../assets/scss/base.scss';

  .parent {
    @include bg-img('../assets/img/common/Bg');
    width: 100%;
  }

  .selectParent {
    display: flex;
    position: fixed;
    margin-top: px2rem(4);
    height: px2rem(98);
    width: px2rem(585);
    left: px2rem(83);
    right: px2rem(83);
    text-align: center;
    bottom: px2rem(64);
    @include bg-img('../assets/img/common/background');

  }

  .selectitem1 {
    // @include bg-img('../assets/img/common/unclass');
    background: url('../assets/img/common/keshi2.jpg') no-repeat 0 0;
    background-size: cover;
    width: px2rem(288);
    height: px2rem(90);
    line-height: px2rem(100);
    flex: 1;
    font-size: px2rem(40);
    text-align: center;
  }

  .selectitem2 {
    // @include bg-img('../assets/img/common/unrecord');
    background: url('../assets/img/common/dangan2.jpg') no-repeat 0 0;
    background-size: cover;
    height: px2rem(90);
    width: px2rem(288);
    line-height: px2rem(100);
    flex: 1;
    font-size: px2rem(40);
    text-align: center;
    color: rgba(0, 0, 0, 0);
  }

  .select1 {
    width: px2rem(288);
    height: px2rem(90);
    color: rgba(0, 0, 0, 0);
  }

  /*.select2{*/
  /*width: px2rem(288);*/
  /*height:px2rem(90);*/
  /*color: rgba(0,0,0,0);*/
  /*}*/

  .u-link--Active1 {
    .select1 {
      padding-top: px2rem(2);
      width: px2rem(288);
      height: px2rem(90);
      // @include bg-img('../assets/img/common/seleclass');
      background: url('../assets/img/common/keshi.jpg') no-repeat 0 0;
      background-size: cover;
    }
  }

  .u-link--Active2 {
    .select1 {
      width: px2rem(288);
      height: px2rem(90);
      // @include bg-img('../assets/img/common/selerecord');
      background: url('../assets/img/common/dangan.jpg') no-repeat 0 0;
      background-size: cover;
    }

  }

  button {
    font-size: px2rem(40);
  }


</style>



// WEBPACK FOOTER //
// ParentMain.vue?465317d4